<template>
    <div class="headerTop">
        <div class="header_section_header">
            <div class="left_aligned_title">
                <div class="header_title">Clasificación de Documentos</div>
                <div class="header_description">
                    Consulta, clasifica y organiza toda la información financiera de tu
                    negocio.
                </div>
            </div>
            <div class="right_aligned_buttons ml-2">
                <div class="button_tipo_contraparte">
                    <div style="min-width: 180px">
                        <SelectComponent :value="selectedType" @input="(v) => $emit('update:selectedType', v)"
                            label="Tipo Contraparte" :weirdOptions="null" :options="typeOptions" />
                    </div>
                </div>
                <div class="button_tipo_contraparte">
                    <div style="min-width: 230px">
                        <SelectComponent :value="selectedRange" @input="(v) => $emit('update:selectedRange', v)"
                            currentIcon="calendar" label="Rango de tiempo"
                            :options="periodDataSelect" :weirdOptions="null" />
                    </div>
                </div>
                <div v-if="localTypeFiles.length > 0" class="button_tipo_contraparte is-justify-content-end">
                    <div style="min-width: 230px">
                        <SelectComponent :value="selectedUploadFile"
                            @input="(v) => $emit('update:selectedUploadFile', v)" :staticLabel="'Subir Documentos'"
                            theme="classification_theme" :weirdOptions="null" currentIcon="UploadFile"
                            :options="localTypeFiles" />
                    </div>
                </div>
                <div :class="['is-align-content-end', 'is-clickable', {'is-disabled-local': getUrlDriveClassification=='' || isDownloadingFile}]">
                    <span class="btnNoClassify is-flex is-justify-content-center is-clickable mr-2"
                        :class="{
                            'theme_dark_btn': isDownloadingFile,
                            'theme_default_btn': !isDownloadingFile}"
                        @click="$emit('download')">
                        <DownloadFile class="ecs" />
                        <!-- Bajar documentos -->
                    </span>
                </div>
            </div>
        </div>
        <div>
            <div class="counterpart_table_header">
                <div class="search_container">
                    <SearchIcon class="search_icon" />
                    <input type="text" class="search_input " :value="searchFilter"
                        @input="(e) => $emit('update:searchFilter', e.target.value)"
                        placeholder="Buscar por nombre o rut" />
                    <button v-if="searchFilter" class="clear_button" @click="$emit('update:searchFilter', '')">
                        <Ecs class="ecs" />
                    </button>
                </div>
                <div style="width: 200px;" class="mr-3">
                    <b-checkbox :class="{
                            'theme_dark_btn': filterTable != '',
                            'theme_default_btn': filterTable == ''}"
                        class="btnNoClassify is-full-width" true-value="Sin Clasificar" :false-value="''"
                        :key="filterTable" :value="filterTable"
                        @input="(v) => $emit('update:filterTable', v)">
                        <span class="pl-0">Sin Clasificar</span>
                    </b-checkbox>
                </div>
                <div style="width: 200px;" class="mr-3">
                    <b-checkbox :class="{
                            'theme_dark_btn': filterTableHasAccrual != '',
                            'theme_default_btn': filterTableHasAccrual == ''}"
                            class="btnNoClassify is-full-width" true-value="Devengados" :false-value="''"
                        :key="filterTableHasAccrual" :value="filterTableHasAccrual"
                        @input="(v) => $emit('update:filterTableHasAccrual', v)">
                        <span class="pl-0">
                            Devengados
                            <CalendarMinus class="ecsFilter" :class="{'iconWhite': filterTableHasAccrual != ''}"/>
                        </span>
                    </b-checkbox>
                </div>
                <div style="width: 200px;" class="mr-3" v-if="allFilterCategories.length >0">
                    <SelectComponent ref="SelectCategoryComponent" :staticLabel="'Categorizados'" :hasSearchBox="true"
                        theme="classification_theme" :isSearchable="true" :weirdOptions="allFilterCategories"
                        iconRight="DashboardSquare"
                        @selected-values="(e) => $emit('selected-categories', e)" :isAccount="true" />
                </div>
                <div style="width: 200px;">
                    <SelectComponent ref="SelectAccountComponent" :staticLabel="'Clasificados'" :hasSearchBox="true"
                        iconRight="RobotFace"
                        theme="classification_theme" :isSearchable="true" :weirdOptions="allAccountsOnDocs"
                        @selected-values="(e) => $emit('selected-accounts', e)" :isAccount="true" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Ecs from "@/components/svg/Ecs.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import CalendarMinus from "@/components/svg/CalendarMinus.vue";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import SelectComponent from "@/components/classification/SelectComponent";

export default {
    name: "ClassificationHeader",
    components: {
        Ecs,
        SearchIcon,
        CalendarMinus,
        DownloadFile,
        SelectComponent,
    },
    props: {
        typeOptions: { type: Array, default: () => [] },
        periodDataSelect: { type: Array, default: () => [] },
        localTypeFiles: { type: Array, default: () => [] },
        selectedType: { type: String, default: "todos" },
        selectedRange: { type: String, default: "" },
        selectedUploadFile: { type: String, default: "" },
        searchFilter: { type: String, default: "" },
        filterTable: { type: String, default: "" },
        filterTableHasAccrual: { type: String, default: "" },
        allFilterCategories: { type: Array, default: () => [] },
        allAccountsOnDocs: { type: Array, default: () => [] },
        getUrlDriveClassification: { type: String, default: "" },
        isDownloadingFile: { type: Boolean, default: false },
    },
    methods: {
        // Expuestos al padre (que recibe los eventos clear/delete desde la tabla)
        // para manejar el estado de checkboxes de los SelectComponent por ref.
        clearAccountFilter() {
            if (this.$refs.SelectAccountComponent) {
                this.$refs.SelectAccountComponent.clearCbList();
            }
        },
        clearCategoryFilter() {
            if (this.$refs.SelectCategoryComponent) {
                this.$refs.SelectCategoryComponent.clearCbList();
            }
        },
        deleteAccountItem(item) {
            if (this.$refs.SelectAccountComponent) {
                this.$refs.SelectAccountComponent.deleteItemCbList(item);
            }
        },
        deleteCategoryItem(item) {
            if (this.$refs.SelectCategoryComponent) {
                this.$refs.SelectCategoryComponent.deleteItemCbList(item);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.headerTop {
    position: sticky;
    top: var(--app-chrome-top, 0px);
    width: 100%;
    background-color: var(--paper-soft);
    z-index: 5;
}

.header_section_header {
    padding-top: 20px;
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    // flex-end alinea los botones del cluster derecho al mismo baseline,
    // independientemente de si tienen label flotando arriba o no.
    align-items: flex-end;
    gap: 24px;
    border-bottom: 1px solid var(--rule);
}

.left_aligned_title {
    flex: 1;
    min-width: 0;
}

.right_aligned_buttons {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 16px;
    margin-bottom: 0;
}

.button_tipo_contraparte {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.header_title {
    font-size: 1.5em;
    font-weight: 700;
    margin-bottom: 4px;
    color: var(--ink);
    line-height: 1.2;
}

.header_description {
    font-size: 1em;
    color: var(--ink-muted);
    line-height: 1.4;
}

.counterpart_table_header {
    background-color: var(--paper-soft);
    border-bottom: 1px solid var(--rule);
    height: 60px;
    width: 100%;
    padding: 12px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.ecsFilter {
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: -5px;
}

.search_container {
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 16px;
}

.search_icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    pointer-events: none;
    color: var(--ink-muted);
}

.search_input {
    width: clamp(100px, 25vw, 300px);
    padding: 8px 36px;
    background-color: var(--paper);
    border: 1px solid var(--rule-strong);
    border-radius: var(--radius);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    font-size: 14px;
    color: var(--ink);
    font-family: inherit;
    box-sizing: border-box;
}

.search_input::placeholder {
    color: var(--ink-faint);
}

.search_input:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-wash);
}

.clear_button {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--ink-faint);
    font-size: 16px;
    line-height: 1;
    padding: 4px;
    z-index: 2;
}

.clear_button:hover {
    color: var(--ink);
}

@media (max-width: 800px) {
    .search_input {
        width: 100%;
    }

    .counterpart_table_header {
        flex-direction: column;
        align-items: stretch;
        height: 120px;
    }
}

@media (max-width: 550px) {
    .counterpart_table_header {
        flex-direction: column;
        align-items: stretch;
        height: 210px;
    }
}

.theme_dark_btn{
    --background-color: #002e33;
    --background-hover: #185555;
    --text-color: #fff;
}

.theme_default_btn{
    --background-color: #FFF;
    --background-hover: #185555;
    --text-color: #333a48;
}

.btnNoClassify {
    padding: 10px 14px;
    align-items: center;
    gap: 8px;
    color: var(--Gray-900, #101828);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--background-color, #FFF);
    color: var(--text-color, #000);

    /* Shadows/shadow-xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    height: 46px;
}

.btnNoClassify:hover{
    background: var(--background-hover);
    color: #fff;
    .ecsFilter, .ecs{
        filter: brightness(0) invert(1);
    }
}

.iconWhite {
    filter: brightness(0) invert(1);
}
</style>
